<template>
	<transition-group name="list" tag="div" class="alert-list">
		<AlertItem
			v-for="alert in alerts"
			:key="alert.id"
			:alert="alert"
			:theme="theme"
		/>
	</transition-group>
</template>

<script>
import AlertItem from './AlertItem'

export default {
	name: 'AlertList',
	components: { AlertItem },
	props: {
		alerts: Array,
		theme: {
			type: String,
			default: 'dark',
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.alert-list {
	position: relative;
	z-index: 10;
	display: flex;
	flex-direction: column;
	align-items: center;
}
:deep(.alert-item) {
	position: relative;
	opacity: 1;
	max-height: 80px;
	display: flex;
	align-items: center;
	background: #ffffff;
	font-family: Avenir-Medium;
	font-size: 14px;
	color: #4f5053;
	letter-spacing: 0;
	margin-top: 12px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
	border-radius: 6px;
	height: 48px;
	padding: 0 16px;
	min-width: 400px;
	max-width: 80vw;
	&.dark {
		background: #141720;
		color: white;
		.alert-close {
			:deep(g),
			:deep(path) {
				fill: var(--neutral-400);
			}
		}
	}
	&.modal {
		// theme used in modals
		width: 100%;
		font-family: Avenir-Heavy;
		box-shadow: none;
		margin-bottom: 16px;
		height: auto;
		min-height: 40px;
		.alert-close {
			:deep(g),
			:deep(path) {
				fill: var(--neutral-400);
			}
		}
		.alert-text {
			white-space: pre-wrap;
		}
		&.error {
			border: 1px solid var(--red-200);
			color: var(--red-200);
		}
		&.success {
			border: 1px solid var(--teal-300);
			color: var(--teal-300);
		}
	}
	&.closeable {
		padding: 12px 12px 12px 16px;
	}
	&.error {
		.alert-close {
			color: #4f5053;
		}
		.progress {
			background-color: var(--red-200);
		}
		.alert-icon {
			--color: #{$error-red};
		}
	}
	&.success {
		.progress {
			background-color: var(--teal-300);
		}
		.alert-icon {
			--color: #{$pronto-green};
		}
	}
	&:first-child {
		margin-top: 0;
	}
	.alert-icon {
		width: 16px;
		height: 16px;
		margin-right: 12px;
		flex-shrink: 0;
	}
	.alert-close {
		cursor: pointer;
		width: 14px;
		height: 14px;
		margin: 4px 0 0 8px;
		flex-shrink: 0;
	}
	.alert-text {
		@include ellipsis();
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
	}
	.progress {
		position: absolute;
		bottom: 0;
		right: 2px;
		border-radius: 0 0 6px 6px;
		display: inline-block;
		height: 2px;
		animation: progress #{var(--delay)} linear;
	}
}

@keyframes progress {
	0% {
		left: 0.2%;
	}
	100% {
		left: 100%;
	}
}

.list-enter-active,
.list-leave-active {
	transition: all ease-out 0.3s;
	transition-property: max-height, opacity;
}
.list-enter,
.list-leave-to {
	opacity: 0;
	max-height: 0;
}
</style>
